export default __webpack_public_path__ + "static/media/pvilla2-2.16cd4c31.webp";